import { Status } from "@common/models";
import { FieldType, SourceType } from "./";

export class Field {
    id: number;
    name: string;
    nameEnglish?: string;
    description: string;
    fieldType: FieldType;
    defaultValue: string;
    required: boolean;
    sourceType: SourceType;
    source: string;
    sourceValue: string;
    sourceText: string;
    status: Status;
    createdAt: Date;
    createdUserId: number;
    updatedAt: Date;
    updatedUserId: number;
}
